const tinycolor = require('tinycolor2')
const colours = {
    oee: {
        // availability:'#ff6624',
        // performance:'#2d73f3',
        // quality:'#f7c68d',
        // oee:'#51bc16'
        // availability:'#56bbef',
        // availability: '#f7c68d',
        // performance: '#305bb6',
        // quality: '#5c5aee',
        oee: '#00a889',

        availability: '#116866',
        performance: '#2A52BE',
        quality: '#5478D9',
        // oee: '#00a889'
    },
    top: '#3EC27C',
    bottom: '#C23E3E'
}
export default {
    methods: {
        getOeeColours(type) {
            return colours.oee[type];
        },
        coloursBasedOnValue(value,idx){
            // top grijs
            //
                if(value < 30){
                    return tinycolor(colours.bottom).darken(60).toRgbString()
                } else if (value < 50){
                    return tinycolor(colours.bottom).darken(40).toRgbString()}
                else if (value < 70){
                        return tinycolor(colours.bottom).darken(20).toRgbString()
                }else if (value < 90){
                    return tinycolor(colours.bottom).darken(5).toRgbString()
                }
            return tinycolor(colours.top).toRgbString()
        },
        coloursBasedOnValueTopBottom(value,type){
            // top grijs
            return     tinycolor(colours[type]).toRgbString()
            // if(value < 30){
            //     return tinycolor(colours[type]).darken(40).toRgbString()
            // } else if (value < 50){
            //     return tinycolor(colours[type]).darken(30).toRgbString()
            // } else if (value < 70){
            //     return tinycolor(colours[type]).darken(20).toRgbString()
            // }else if (value < 90){
            //     return tinycolor(colours[type]).darken(5).toRgbString()
            // }
            // return tinycolor(colours[type]).toRgbString()
        }
    },
    computed: {
        getTopColour() {
            return colours.top
        },
        getBottomColour() {
            return colours.bottom
        },

    }


}